import { type GetVisualizationPropsArgs } from '../../models';

const initialTransforms = ({
    config: anyConfig,
    execution,
    type,
    title,
    description,
    id,
    activeControls,
    params,
    ...rest
}: GetVisualizationPropsArgs) => {
    const meta = execution?.metadata;

    return {
        ...rest,
        data: [...(execution.rows ?? [])],
        options: { ...(anyConfig?.options ?? {}) },
        meta,
        params,
        activeControls,
        type,
        executionId: execution.executionId,
        title,
        description,
        id,
    };
};

export { initialTransforms };
